import { render, staticRenderFns } from "./NotesFormContainer.vue?vue&type=template&id=1d7683e3&scoped=true&"
import script from "./NotesFormContainer.vue?vue&type=script&lang=js&"
export * from "./NotesFormContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotesFormContainer.vue?vue&type=style&index=0&id=1d7683e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7683e3",
  null
  
)

export default component.exports